// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"17":"infoboxcomparison","278":"infobox","522":"Debugger","663":"credits","668":"textbanner","923":"infoboxvideo"}[chunkId] || chunkId) + "-legacy." + {"17":"438d4290","22":"3b1583a4","278":"2b4749f6","522":"4b14211c","652":"ca376c2f","663":"cf50a8c2","668":"228cb3db","923":"475f6f93"}[chunkId] + ".js";
};